module.exports = __webpack_public_path__ + "static/media/cultist-purple.abb4d48d.svg";